<template>
  <div class="container_reg">
    <b-container fluid class="header">
      <b-row>
        <b-col>
          <div @click="backOrRedirect()" style="cursor:pointer;">
            <font-awesome-icon style="font-size:32px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'times']"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <RegisterForm style="padding-bottom:80px;" />
  </div>
</template>

<script>
import colors from '@/mixins/colors'
import RegisterForm from '@/components/RegisterForm.vue'
import navigation from '@/mixins/navigation'

export default {
  name: 'Register',
  components: {RegisterForm},
  mixins: [colors, navigation],

  methods: {
    backOrRedirect () {
      if (this.$route.query && this.$route.query.ref) {
        window.location = this.$route.query.ref
      } else {
        this.back()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container_reg {
  width:100vw;
  // max-width: 1330px;
  //background-color: #2C2A29;
  background-color: #FFFFFF;
}
.header{
  width : calc(100vw);
  // max-width: 1330px;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  height: 46px;
  text-align:right;
  top: 10px;
}

.content_form {
  padding:10px 20px;
}
</style>
